import * as React from 'react';

const NavDivider = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={49}
    fill="none"
    {...props}
  >
    <circle cx="-72" cy="24" r="76.5" stroke="#3E5266" />
  </svg>
);
export default NavDivider;
